<template>
  <a-card size="small" title="云产品分布图" class="p-0">
    <div class="provider-chart">
      <e-chart
        style="width: 100%; height: 100%;"
        :options="options"
        autoresize
        dom-id="opensource-provider-chart" />
    </div>
  </a-card>
</template>

<script>
export default {
  name: 'ProviderChart',
  props: {
    data: Object,
  },
  computed: {
    options () {
      const { providers = {} } = this.data
      const xAxisDatas = []

      Object.keys(providers).forEach(key => {
        if (!xAxisDatas.some(item => item.name === key)) {
          xAxisDatas.push({ name: key, value: providers[key] })
        }
      })
      xAxisDatas.sort((a, b) => b.value - a.value)
      return {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '1%',
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            crossStyle: {
              color: '#999',
            },
          },
        },
        legend: {
          data: ['Provider'],
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisDatas.map(item => item.name),
            axisPointer: {
              type: 'shadow',
            },
            axisLabel: {
              rotate: 45,
              interval: 0,
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
          },
        ],
        series: [
          {
            name: 'Provider',
            type: 'bar',
            data: xAxisDatas.map(item => providers[item.name] || 0),
          },
        ],
      }
    },
  },
}
</script>

<style lang="less" scoped>
.provider-chart {
  height: 350px;
  ::v-deep {
    .echarts {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
